import { PhononetSettings } from '../SettingsState';
import { RootState } from '../../RootState';

const selectPhononetSettings = ({ settings: { settings } }: RootState): PhononetSettings => {
  if (settings === null) {
    throw new Error('Phononet settings should be initialized.');
  }

  return settings.phononetSettings;
};

export default selectPhononetSettings;
